import { facadeApi } from 'api'
import { PageSize } from 'constants/pageSize'
import { UserAssignedRoles } from 'types/users/users'

interface UserSelfAssignedRolesData {
  data: UserAssignedRoles[]
}

export const fetchSelfAssignedRolesApi = () =>
  facadeApi.get<UserSelfAssignedRolesData>('/users/me/assigned-roles', {
    params: {
      offset: 0,
      limit: PageSize.All,
    },
  })
